import { render, staticRenderFns } from "./IFProfitLoss.vue?vue&type=template&id=164e9ae5"
import script from "./IFProfitLoss.vue?vue&type=script&lang=js"
export * from "./IFProfitLoss.vue?vue&type=script&lang=js"
import style0 from "./IFProfitLoss.vue?vue&type=style&index=0&id=164e9ae5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports